import {createApp} from 'vue'
import CTABox from './CTABox'

const el = '.kb-component--cta-box'
console.log('el', el)

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CTABoxDOM)=>{
            const result = JSON.parse(CTABoxDOM.dataset.result)
            const ctaId = CTABoxDOM.dataset.ctaId
            const component = createApp(CTABox, { result, ctaId }).use(Store)
            component.mount(CTABoxDOM)
        })
    }
}